import SelectTeamsDropdown from './SelectTeamsDropdown';

export default SelectTeamsDropdown;
